import { LogoutModal, Notification, SidebarMenu } from "@/components/common";
import { DhamhaAungLanLogo } from "@/components/common/icons";
import { useUserStore } from "@/states/zustand/user";
import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import { Link, Navigate, Outlet } from "react-router";

export function MainLayout() {
    const jwt = useUserStore(state => state.jwt);

    if (!jwt || !jwt.token) return <Navigate to={"/login"} replace />

    return (
        <Layout
            hasSider
            className="!min-h-screen flex flex-row"
        >
            <Sider
                width={320}
                className="!bg-2C !sticky !top-0 h-[100vh] overflow-auto [&>.ant-layout-sider-children]:flex [&>.ant-layout-sider-children]:flex-col "
            >
                <Link
                    to={'/'}
                >
                    <div
                        className="space-y-4 py-2 px-6 border-b-2 border-white/30"
                    >
                        <DhamhaAungLanLogo
                            size={56}
                        />
                        <article
                            className="space-y-0.5"
                        >
                            <h2
                                className="text-base text-primary-gradient"
                            >
                                ဓမ္မအောင်လံ ဝိပဿနာရိပ်သာ
                            </h2>
                            <p
                                className="text-sm text-white"
                            >
                                Admin Dashboard
                            </p>
                        </article>
                    </div>
                </Link>
                <div
                    className="flex-1"
                >
                    <SidebarMenu />
                </div>
                <LogoutModal />
            </Sider>
            <Content
                className="m-6 p-5 rounded-md border border-black/10 shadow bg-white"
            >
                <Notification />
                <Outlet />
            </Content>
        </Layout>
    )
}
